export const jiraBrowseTicketLink = (jiraEpic) => {
  return `https://accelbyte.atlassian.net/browse/${jiraEpic}`;
};

export const jiraEpicPayload = (jiraEpic) => {
  const raw = {
    expand: ['names', 'schema', 'operations'],
    fields: ['summary', 'status', 'assignee'],
    fieldsByKeys: false,
    jql: `parent = ${jiraEpic}`,
    maxResults: 30,
    startAt: 0,
  };

  return JSON.stringify(raw);
};
